import { render, staticRenderFns } from "./CopyToClipboard.vue?vue&type=template&id=f636f6ae&scoped=true&"
import script from "./CopyToClipboard.vue?vue&type=script&lang=ts&"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts&"
import style0 from "./CopyToClipboard.vue?vue&type=style&index=0&id=f636f6ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f636f6ae",
  null
  
)

export default component.exports